import React, { Component } from 'react';
import AccountSettingsStore from 'stores/AccountSettingsStore'
import { FormControl, Button } from 'react-bootstrap'
import Fontawesome from 'react-fontawesome'
import { Checkbox } from 'react-icheck'
import './Item.css'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {data:[]}
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.settings.show&&newProps.settings.show!==this.props.settings.show) {
  //     this.loadData()
  //   }
  // }

  loadData() {
    AccountSettingsStore.loadDocumentPrint((result)=>{
      this.setState({data:result.data})
    })
  }

  onFormChange(index,field,e) {
    let {data} = this.state
    data[index][field] = e.target.value
    this.setState({data:data})
  }

  onCheckChange(index,field) {
    let {data} = this.state
    data[index][field] = !data[index][field]
    this.setState({data:data})
  }

  onSaveClick() {
    let {data} = this.state
    let {messages} = this.props
    let postData = data
    AccountSettingsStore.saveDocumentPrint(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:messages['Notice'],
          message:messages['Success Msg'],
          level:'info',
          position:'tc'
        });
      }  
    },()=>{
      this._notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Error Msg'],
        level:'error',
        position:'tc'
      });  
    })    
  }

  renderRowData() {
    let {data} = this.state
    let {messages} = this.props
    if (data.length===0) {
      return(<tr><td colSpan={8}>{messages['No Data']}</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.doc_id}</td>
              <td className='text-center'><FormControl onChange={this.onFormChange.bind(this,index,'doc_name')} value={item.doc_name} /></td>
              <td className='text-center'><FormControl componentClass='textarea' rows={3} onChange={this.onFormChange.bind(this,index,'remark')} value={item.remark} /></td>
              <td className='text-center'>
                <Checkbox
                  onChange={this.onCheckChange.bind(this,index,'part_first')}
                  checked={item.part_first}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=''
                />
              </td>
              <td className='text-center'>
                <Checkbox
                  onChange={this.onCheckChange.bind(this,index,'hide_shop_name')}
                  checked={item.hide_shop_name}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=''
                />
              </td>
              <td className='text-center'>
                <Checkbox
                  onChange={this.onCheckChange.bind(this,index,'show_car')}
                  checked={item.show_car}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=''
                />
              </td>
              <td className='text-center'><FormControl onChange={this.onFormChange.bind(this,index,'signed_owner_text')} value={item.signed_owner_text} /></td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th style={{width:'50px'}} className='text-center'>{messages['Seq']}</th>
              <th style={{width:'100px'}} className='text-center'>{messages['Doc Title']}</th>
              <th style={{width:'150px'}} className='text-center'>{messages['Doc Name']}</th>
              <th style={{width:'150px'}} className='text-center'>{messages['Remark']}</th>
              <th style={{width:'100px'}} className='text-center'>{messages['Part First']}</th>
              <th style={{width:'100px'}} className='text-center'>{messages['Hide Shop Name']}</th>
              <th style={{width:'100px'}} className='text-center'>{messages['Show Car']}</th>
              <th style={{width:'150px'}} className='text-center'>{messages['Signed Owner Text']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderFormButton() {
    let {messages} = this.props
    return(
      <div className='text-right'>
        <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><Fontawesome name='save' /> {messages['Save']}</Button>
      </div>
    )
  }

  render() {
    let {messages} = this.props
    return(
  		<div className='account-settings-menu-2'>
  			<h3>{messages['Doc Print Config']}</h3>
        {this.renderTable()}
        <br />
        {this.renderFormButton()}
        <NotificationSystem ref="notificationSystem" />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu2.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu2/Item.js